export enum CellGroupTheme {
  DEFAULT = 'default',
  ON_WHITE_BOX = 'on-white-box',
}
export interface CellGroupProps {
  groupName?: string
  theme?: CellGroupTheme
}
